export const GET_CONNECTED_ACCOUNTS_CONFIG = "GET_CONNECTED_ACCOUNTS_CONFIG"
export const GET_CONNECTED_ACCOUNTS_CONFIG_SUCCESS =
  "GET_CONNECTED_ACCOUNTS_CONFIG_SUCCESS"
export const GET_CONNECTED_ACCOUNTS_CONFIG_FAILED =
  "GET_CONNECTED_ACCOUNTS_CONFIG_FAILED"
export const RESET_CONNECTED_ACCOUNTS_CONFIG = "RESET_CONNECTED_ACCOUNTS_CONFIG"

export const GET_CONNECTED_ACCOUNTS_LIST = "GET_CONNECTED_ACCOUNTS_LIST"
export const GET_CONNECTED_ACCOUNTS_LIST_SUCCESS =
  "GET_CONNECTED_ACCOUNTS_LIST_SUCCESS"
export const GET_CONNECTED_ACCOUNTS_LIST_FAILED =
  "GET_CONNECTED_ACCOUNTS_LIST_FAILED"
export const RESET_CONNECTED_ACCOUNTS_LIST = "RESET_CONNECTED_ACCOUNTS_LIST"

export const SAVE_PAYOUTS = "SAVE_PAYOUTS"
export const SAVE_PAYOUTS_SUCCESS = "SAVE_PAYOUTS_SUCCESS"
export const SAVE_PAYOUTS_FAILED = "SAVE_PAYOUTS_FAILED"

export const SET_STRIPE_MAIN_ACCOUNT = "SET_STRIPE_MAIN_ACCOUNT"
export const SET_STRIPE_MAIN_ACCOUNT_SUCCESS = "SET_STRIPE_MAIN_ACCOUNT_SUCCESS"
export const SET_STRIPE_MAIN_ACCOUNT_FAILED = "SET_STRIPE_MAIN_ACCOUNT_FAILED"

export const DISCONNECT_STRIPE_ACCOUNT = "DISCONNECT_STRIPE_ACCOUNT"
export const DISCONNECT_STRIPE_ACCOUNT_SUCCESS =
  "DISCONNECT_STRIPE_ACCOUNT_SUCCESS"
export const DISCONNECT_STRIPE_ACCOUNT_FAILED =
  "DISCONNECT_STRIPE_ACCOUNT_FAILED"

export const OPEN_DISCONNECT_STRIPE_ACCOUNT_MODAL =
  "OPEN_DISCONNECT_STRIPE_ACCOUNT_MODAL"
export const HIDE_DISCONNECT_STRIPE_ACCOUNT_MODAL =
  "HIDE_DISCONNECT_STRIPE_ACCOUNT_MODAL"

export const GET_STRIPE_CONNECTED_ACCOUNT = "GET_STRIPE_CONNECTED_ACCOUNT"
export const GET_STRIPE_CONNECTED_ACCOUNT_SUCCESS =
  "GET_STRIPE_CONNECTED_ACCOUNT_SUCCESS"
export const GET_STRIPE_CONNECTED_ACCOUNT_FAILED =
  "GET_STRIPE_CONNECTED_ACCOUNT_FAILED"
